class ReviewsSection extends HTMLElement {
  constructor() {
    super()
    this.sliderElement = this.querySelector('.testimonial-homepage-slider')
    this.sliderSwiper = this.querySelector('.swiper')?.swiper
    if(!!!this.sliderElement) return

    this.initSlider()

    this.slides = this.querySelectorAll('.swiper-slide')
    this.filters = this.querySelectorAll('[data-filter-title]')
    this.pagination = this.querySelector('.swiper-pagination')
    this.dots = this.querySelectorAll('.swiper-pagination .swiper-pagination-bullet')

    if(this.filters.length > 0) this.setSlidesClass()

    this.initModal()

    if(this.slides) this.setReadMore()

    this.filters.length > 0 && this.filters.forEach(filter => filter.addEventListener('click', this.onFilterClick.bind(this)))
  }
  onFilterClick(e) {
    const target = e.target
    const filterTitle = target.getAttribute('data-filter-title')
    this.setActiveFilter(filterTitle)

    const isAllFilter = filterTitle.includes('all')

    this.slides.forEach(slide => {
      const shouldShow = isAllFilter || slide.getAttribute('data-swiper-match-title') === filterTitle
      slide.classList.toggle('swiper-slide', shouldShow)
    })


    this.setSlidesClass()
    this.resetSlider()
    this.initSlider()
  }
  setSlidesClass() {
    const visibleSlides = [...this.slides].filter(slide => slide.classList.contains('swiper-slide'))
    if (visibleSlides.length > 0) {
      visibleSlides.forEach((slide, index) => {
        slide.classList.toggle('first-swiper-slide', index === 0)
        slide.classList.toggle('last-swiper-slide', index === visibleSlides.length - 1)
      })
    }
  }
  initSlider() {
    const infinite = this.sliderElement.getAttribute('data-infinite') === 'true'
    const slidesPerViewDesktop = this.sliderElement.getAttribute('data-slides-per-view-desktop') || 4
    const autoHeight = this.sliderElement.getAttribute('data-slider-autoheight') === 'true'

    this.sliderSwiper = new Swiper(this.sliderElement, {
      loop: infinite,
      slidesPerView: parseInt(slidesPerViewDesktop) === 4 ? "auto" : 1,
      paginationClickable: true,
      spaceBetween: parseInt(slidesPerViewDesktop) === 4 ? 16 : 24.5,
      simulateTouch: false,
      autoHeight: autoHeight,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: parseInt(slidesPerViewDesktop) === 4 ? "auto" : parseInt(slidesPerViewDesktop),
          spaceBetween: parseInt(slidesPerViewDesktop) === 4 ? 28 : 48
        },
        1441: {
          slidesPerView: parseInt(slidesPerViewDesktop),
          spaceBetween: parseInt(slidesPerViewDesktop) === 4 ? 28 : 48
        }
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".testimonials-homepage-swiper-button-next",
        prevEl: ".testimonials-homepage-swiper-button-prev",
      },
    })

    this.pagination = this.querySelector('.swiper-pagination')
    this.dots = this.querySelectorAll('.swiper-pagination .swiper-pagination-bullet')

    const dots = [...this.dots]
    const pagination = this.pagination
    const dotWidth = 16
    const dotsPerPage = 5
    pagination.scrollLeft = 0
    
    if(dots.length <= dotsPerPage) return

    this.sliderSwiper.on('slideChange', () => {
      const realIndex = this.sliderSwiper.realIndex
      const currentGroup = Math.floor((realIndex) / dotsPerPage)
      const newScrollLeft = dotWidth * dotsPerPage * currentGroup
  
      pagination.scrollLeft = newScrollLeft
    })
  }
  resetSlider() {
    this.sliderSwiper.destroy()
  }
  setActiveFilter(currentFilter) {
    this.filters.forEach(filter => {
      let statusFilter = filter.getAttribute('data-filter-title')
      filter.classList.toggle('is-active', statusFilter === currentFilter)
    }) 
  }
  setReadMore() {
    this.slides.forEach(slide => {
      const description = slide.querySelector('.custom-slide-item__description p')
      slide.classList.toggle('has-more-text', description.scrollHeight > 160)
      if(slide.classList.contains('has-more-text')) {
        const readMoreButton = slide.querySelector('.custom-slide-item__read-more')
        readMoreButton.addEventListener('click', this.onReadMoreClick.bind(this))
      }
    })
  }
  initModal() {
    this.modal = this.querySelector('.reviews-modal')
    this.modalClose = this.modal.querySelectorAll('.reviews-modal__close')
    this.modalTitle = this.modal.querySelector('.reviews-modal__title')
    this.modalDescription = this.modal.querySelector('.reviews-modal__description')
    this.modalAuthor = this.modal.querySelector('.reviews-modal__author')

    this.modalClose.forEach(close => close.addEventListener('click', this.triggerReviewsModal.bind(this)))
  }
  onReadMoreClick(e) {
    const target = e.target
    const title = target.getAttribute('data-review-title')
    const description = target.getAttribute('data-review-description')
    const author = target.getAttribute('data-review-author')
    this.modalTitle.textContent = title
    this.modalDescription.textContent = description
    this.modalAuthor.textContent = author
    this.triggerReviewsModal()
  }
  triggerReviewsModal() {
    this.modal.toggleAttribute('open')
  }
}

customElements.define('reviews-section', ReviewsSection)